import { jsx as _jsx } from "react/jsx-runtime";
import InputTextField from "../TextField/InputTextField";
import { conformToMask } from "react-text-mask";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
const kmMask = createNumberMask({
    prefix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: false,
});
const KilometerInput = ({ inputLabel = 'quilometragem', onChange, value, initialValue, ...props }) => {
    const maskNumberValue = (numberValue) => {
        if (numberValue) {
            const { conformedValue } = conformToMask(numberValue.toString(), kmMask);
            return conformedValue;
        }
        return '';
    };
    const handleChange = (e, currentValue) => {
        if (currentValue.length > 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange(parseInt(currentValue), e);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined, e);
        }
    };
    return (_jsx(InputTextField, { "aria-label": inputLabel === null || inputLabel === void 0 ? void 0 : inputLabel.toString(), inputCustomMask: kmMask, inputLabel: inputLabel, onChange: handleChange, value: value ? maskNumberValue(value) : undefined, initialValue: maskNumberValue(initialValue), maxLength: 8, ...props }));
};
export default KilometerInput;
//# sourceMappingURL=KilometerInput.js.map